export default __webpack_public_path__ + "static/media/mobile-development.2eaadb26.svg";